// Occasion Selector Enhancement
document.addEventListener('DOMContentLoaded', function() {
  // Function to update cart attributes with the selected occasion
  if (typeof Swiper !== 'undefined') {
    document.querySelectorAll('.occasion-swiper').forEach(swiperEl => {
      new Swiper(swiperEl, {
      scrollbar: {
        el: swiperEl.parentNode.querySelector('.swiper-scrollbar'),
        draggable: true,
      },
      slidesPerView: 'auto',
      spaceBetween: 10,
      breakpoints: {
        320: {
        slidesPerView: 'auto'
        }
      }
      });

      // Apply maximum width of 90px to swiper slides within this swiper
      swiperEl.querySelectorAll('.swiper-slide').forEach(slide => {
      slide.style.maxWidth = '90px';
      slide.style.width = 'auto';
      });
    });
  }

  // Function to handle occasion selection
  function handleOccasionSelection(event) {
    const selectedOccasion = event.target.value;
    const occasionInput = document.querySelector(".cart-drawer__footer [data-cart-footer-occasion]");
    // remove the checked attribute from all other radio buttons
    document.querySelectorAll('input[name="occasion"]').forEach(radio => {
      if (radio !== event.target) {
        radio.removeAttribute('checked');
      }
    });
    // add the checked attribute to the selected radio button
    event.target.setAttribute('checked', 'checked');
    if (occasionInput) {
      occasionInput.value = selectedOccasion;
    }
  }

  // Attach event listeners to all occasion radio buttons
  document.querySelectorAll('input[name="occasion"]').forEach(radio => {
    radio.addEventListener('change', handleOccasionSelection);
  });
});
